module.exports = __webpack_public_path__ + "img/logo-1.dc647199.png";